export const taxInvoiceConfig = {
  apiType: "tax-invoice",
  kind: "tax-invoice",
  basePath: "/admin/tax-invoices",
  entity: "Tax Invoice",
  listTitle: "Saved Tax Invoices",
  newTitle: "New Tax Invoice",
  editTitle: "Edit Tax Invoice",
  numberPrefix: "TI",
  docTitle: "TAX INVOICE",
  docTitleAr: "فاتورة ضريبية",
  serialLabel: "Sl. No",
  hasVat: true,
  vatRate: 5,
  hasTrn: true,
  defaultCompanyTrn: "104962862900003",
  testidPrefix: "tax-invoice",
};

export const cashInvoiceConfig = {
  apiType: "cash-invoice",
  kind: "cash-invoice",
  basePath: "/admin/cash-invoices",
  entity: "Cash Invoice",
  listTitle: "Saved Cash Invoices",
  newTitle: "New Cash Invoice",
  editTitle: "Edit Cash Invoice",
  numberPrefix: "CI",
  docTitle: "CASH INVOICE",
  docTitleAr: "فاتورة نقداً",
  serialLabel: "Item No",
  hasVat: false,
  vatRate: 0,
  hasTrn: false,
  testidPrefix: "cash-invoice",
};
